import { Component, effect, inject, model, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgIcon, provideIcons } from '@ng-icons/core';
import {
  lucidePenLine,
  lucidePackage,
  lucideTrash2,
  lucideChevronLeft,
} from '@ng-icons/lucide';

import { CrudService } from '../../core/services/crud.service';
import { ColorTotalComponent } from '../../shared/components/color-total/color-total.component';
import { DecimalPipe, CurrencyPipe } from '@angular/common';
import { RollFormComponent } from '../roll-form/roll-form.component';
import { DataTableComponent } from '../../shared/components/data-table/data-table.component';
import { DataTableColumn } from '../../shared/components/data-table/data-table.models';

@Component({
  selector: 'app-roll-list',
  imports: [
    NgIcon,
    RollFormComponent,
    ColorTotalComponent,
    DataTableComponent
  ],
  providers: [
    DecimalPipe,
    CurrencyPipe
  ],
  viewProviders: [
    provideIcons({
      lucidePenLine,
      lucidePackage,
      lucideTrash2,
      lucideChevronLeft,
    }),
  ],

  templateUrl: './roll-list.component.html',
  styles: ``,
})
export class RollListComponent implements OnInit {
  private crudService = inject(CrudService);
  private router = inject(Router);
  private decimalPipe = inject(DecimalPipe);
  private currencyPipe = inject(CurrencyPipe);

  productId = '';
  productName = '';
  productDescription = '';

  productRolls: Array<any> = [];

  columns: DataTableColumn<any>[] = [
    { key: 'roll_identifier', label: 'ID', sortable: true },
    { key: 'supplier_name', label: 'Proveedor', sortable: true },
    { key: 'warehouse_name', label: 'Almacén', sortable: true },
    { key: 'color', label: 'Color', type: 'custom', align: 'center', sortable: true, sortValue: row => row.color },
    { key: 'width', label: 'Ancho', sortable: true, align: 'right', renderString: row => this.decimalPipe.transform(row.width, '1.2-2') || '', sortValue: row => row.width, sortType: 'number' },
    { key: 'current_length_meters', label: 'Actual <br/>(m)', sortable: true, align: 'right', renderString: row => this.decimalPipe.transform(row.current_length_meters, '1.2-2') || '', sortValue: row => row.current_length_meters, sortType: 'number' },
    { key: 'current_weight_kg', label: 'Actual <br/>(kg)', sortable: true, align: 'right', renderString: row => this.decimalPipe.transform(row.current_weight_kg, '1.2-2') || '', sortValue: row => row.current_weight_kg, sortType: 'number' },
    { key: 'reserved_length_meters', label: 'Reservado <br/>(m)', sortable: true, align: 'right', renderString: row => this.decimalPipe.transform(row.reserved_length_meters, '1.2-2') || '', sortValue: row => row.reserved_length_meters, sortType: 'number' },
    { key: 'reserved_weight_kg', label: 'Reservado <br/>(kg)', sortable: true, align: 'right', renderString: row => this.decimalPipe.transform(row.reserved_weight_kg, '1.2-2') || '', sortValue: row => row.reserved_weight_kg, sortType: 'number' },
    { key: 'purchase_cost', label: 'Costo / UDM', sortable: true, align: 'right', renderString: row => `${this.currencyPipe.transform(row.purchase_cost, 'MXN')} / ${row.purchase_cost_uom}`, sortValue: row => row.purchase_cost, sortType: 'number' },
    { key: 'status', label: 'Estatus', sortable: true, align: 'center' },
    { key: 'actions', label: 'Acciones', type: 'custom', align: 'center', widthClass: 'w-1/12' }
  ];

  existingRoll: any;

  showModal = model(false);

  constructor() {
    effect(() => {
      if (!this.showModal()) {
        this.getRolls();
      }
    });
  }

  ngOnInit(): void {
    if (history.state) {
      this.productId = history.state.product.id;
      this.productName = history.state.product.name;
      this.productDescription = history.state.product.description;
      this.getRolls();
    } else {
      this.router.navigate(['/inventario']);
    }
  }

  openModal() {
    this.existingRoll = null;
    this.showModal.set(true);
  }

  getRolls() {
    this.crudService.getProductRollsByProductId(this.productId).subscribe({
      next: (response: any) => {
        if (response.ok) {
          this.productRolls = response.body;
          // console.log(this.productRolls);
        }
      },
    });
  }

  updateRoll(roll: any) {
    this.existingRoll = roll;
    this.showModal.set(true);
  }

  deleteRoll(rollId: string) {
    this.crudService.deleteProductRoll(rollId).subscribe({
      next: (response: any) => {
        if (response.ok) {
          this.getRolls();
        }
      },
    });
  }
}
